import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SwiperModule } from 'angular2-useful-swiper';
import { ButtonToggleGroupComponent } from './components/button-toggle-group/button-toggle-group.component';
import { ChangeCountComponent } from './components/change-count/change-count.component';
import { ClassRequestComponent } from './components/class-request/class-request.component';
import { ClubConsentCheckboxesComponent } from './components/club-consent-checkboxes/club-consent-checkboxes.component';
import { ClubSearchComponent } from './components/club-search/club-search.component';
import { DateToggleGroupComponent } from './components/date-toggle-group/date-toggle-group.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { Html5QrcodeComponent } from './components/html5-qrcode-reader/html5-qrcode-reader.component';
import { LeftArrowComponent } from './components/left-arrow/left-arrow.component';
import { EmailLoginComponent } from './components/login/email-login/email-login.component';
import { LoginAndPasswordLoginComponent } from './components/login/login-and-password-login/login-and-password-login.component';
import { ClassLoginComponent } from './components/login/login.component';
import { PhoneLoginComponent } from './components/login/phone-login/phone-login.component';
import { PushLoginComponent } from './components/login/push-login/push-login.component';
import { RegistrationComponent } from './components/login/registration/registration.component';
import { RestorePasswordComponent } from './components/login/restore-password/restore-password.component';
import { SequentialRegistrationComponent } from './components/login/sequential-registration/sequential-registration.component';
import { ModalComponent } from './components/modal/modal.component';
import { PaymentModalComponent } from './components/payment-modal/payment-modal.component';
import { PreloaderComponent } from './components/preloader/preloader.component';
import { QrOrScannerReaderComponent } from './components/qr-or-scanner-reader/qr-or-scanner-reader.component';
import { RightArrowComponent } from './components/right-arrow/right-arrow.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { DateMaskDirective } from './directives/date-mask.directive';
import { PhoneMaskDirective } from './directives/phone-masc.directive';
import { PluralDirective } from './directives/plural.directive';
import { CheckTodayPipe } from './pipes/check-today.pipe';
import { ClubDownTimeFilterPipe } from './pipes/club-down-time-filter.pipe';
import { DicPipe } from './pipes/dic.pipe';
import { DurationPipe } from './pipes/duration.pipe';
import { HasFilledPipe } from './pipes/has-filled.pipe';
import { ParseVariantName } from './pipes/helpers.pipe';
import { ModalWrapperComponent } from './services/modal/modal-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    RouterModule,
  ],
  declarations: [
    HasFilledPipe,
    DurationPipe,
    CheckTodayPipe,
    ClickOutsideDirective,
    PhoneMaskDirective,
    DateMaskDirective,
    DropdownComponent,
    ModalComponent,
    PreloaderComponent,
    ClassRequestComponent,
    ClubConsentCheckboxesComponent,
    ClassLoginComponent,
    SpinnerComponent,
    ClubSearchComponent,
    DicPipe,
    ParseVariantName,
    EmailLoginComponent,
    PhoneLoginComponent,
    LoginAndPasswordLoginComponent,
    PushLoginComponent,
    RegistrationComponent,
    SequentialRegistrationComponent,
    RestorePasswordComponent,
    ClubDownTimeFilterPipe,
    ChangeCountComponent,
    ModalWrapperComponent,
    PaymentModalComponent,
    QrOrScannerReaderComponent,
    Html5QrcodeComponent,
    ButtonToggleGroupComponent,
    PluralDirective,
    LeftArrowComponent,
    RightArrowComponent,
    DateToggleGroupComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    HasFilledPipe,
    DurationPipe,
    DicPipe,
    CheckTodayPipe,
    ClickOutsideDirective,
    PhoneMaskDirective,
    DateMaskDirective,
    DropdownComponent,
    ModalComponent,
    SpinnerComponent,
    PreloaderComponent,
    ClassRequestComponent,
    ClubConsentCheckboxesComponent,
    ClassLoginComponent,
    ClubSearchComponent,
    ClubDownTimeFilterPipe,
    EmailLoginComponent,
    PhoneLoginComponent,
    LoginAndPasswordLoginComponent,
    PushLoginComponent,
    RegistrationComponent,
    RestorePasswordComponent,
    ChangeCountComponent,
    QrOrScannerReaderComponent,
    ParseVariantName,
    ButtonToggleGroupComponent,
    PluralDirective,
    LeftArrowComponent,
    RightArrowComponent,
    DateToggleGroupComponent,
  ],
})
export class SharedModule {}
